import { Link, NavLink } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { useCart } from '../context/CartContext';
import { useAuth } from '../lib/useAuth';
import { auth } from '../lib/supabase';

export default function Navbar() {
  const { lang, setLang, t } = useLang();
  const { count } = useCart();
  const { session, isStaff } = useAuth();

  return (
    <nav className="nav">
      <div className="nav-inner">
        <Link to="/" className="nav-brand">🌊 Life in Nha Trang</Link>
        <div className="nav-links">
          <NavLink to="/">{t('nav.home')}</NavLink>
          <NavLink to="/products">{t('nav.products')}</NavLink>
          <NavLink to="/story">{t('nav.story')}</NavLink>
          <NavLink to="/sale">{t('nav.sale')}</NavLink>
          <NavLink to="/contact">{t('nav.contact')}</NavLink>
        </div>
        <div className="nav-right">
          <div className="lang-switch">
            <button className={lang === 'vi' ? 'active' : ''} onClick={() => setLang('vi')}>VI</button>
            <button className={lang === 'en' ? 'active' : ''} onClick={() => setLang('en')}>EN</button>
          </div>
          {isStaff && <Link to="/admin" className="btn btn-secondary btn-sm">{t('nav.admin')}</Link>}
          {session ? (
            <button className="btn btn-ghost btn-sm" onClick={() => auth.signOut()}>{t('nav.logout')}</button>
          ) : (
            <Link to="/login" className="btn btn-ghost btn-sm">{t('nav.login')}</Link>
          )}
          <Link to="/cart" className="cart-link" aria-label="Cart">
            🛒{count > 0 && <span className="cart-badge">{count}</span>}
          </Link>
        </div>
      </div>
    </nav>
  );
}
